window.addEventListener("message", (ev) => {
  if (ev.origin !== "https://charts3.equitystory.com") {
    return;
  }

  const payload = ev.data;

  if (typeof payload !== "string") {
    return
  }

  if (!payload.startsWith("equitystory-chart-")) {
    return;
  }

  const separatorPosition = payload.indexOf(" ");
  if (separatorPosition === -1) {
    return;
  }

  const frameId = payload.substring(0, separatorPosition);
  const frameDocumentHeight = payload.substring(separatorPosition + 1);
  if (frameDocumentHeight === "") {
    return;
  }

  const frameElement = document.getElementById(frameId);
  if (!(frameElement instanceof HTMLIFrameElement)) {
    return;
  }

  frameElement.height = frameDocumentHeight;
});
